import * as constants from '../constants'
import { closedPositionsQuery } from '../graphql/schema'
import { GraphQLAction } from '../actions/GraphQLActions'
import { CLEAR_STATE } from '../constants'
import { ClearState } from '../actions/commonActions'

export function history(
  historyState: closedPositionsQuery = defaultState,
  action: GraphQLAction | ClearState
): closedPositionsQuery {
  switch (action.type) {
    case constants.GET_CLOSED_POSITIONS: {
      return { ...historyState }
    }
    case constants.FULFILL_GET_CLOSED_POSITIONS: {
      const payload: closedPositionsQuery = action.closedPosition
      // const closedPositions = payload.closedPositions!;
      return payload ? { ...payload } : { ...historyState }
    }
    case CLEAR_STATE: {
      return { ...defaultState }
    }
    default:
      return historyState
  }
}

const defaultState = { closedPositions: [] }
